export interface MessageTrackingParams {
  campaign: string
  campaignMedium: string
  status: string
  dateSent: string
  scheduledFor?: string
  uuid: string
  contactUsed: string
  resendable: boolean
}

export function constructorMessageTracking(data: any) {
  const message_trackings: MessageTrackingParams[] = data.map(
    (message_tracking: any) => {
      return {
        campaign: message_tracking?.campaign,
        campaignMedium: message_tracking?.medium,
        status: message_tracking?.status,
        dateSent: message_tracking?.date_sent,
        scheduledFor: message_tracking?.scheduled_for,
        uuid: message_tracking?.uuid,
        contactUsed: message_tracking?.contact_used,
        resendable: message_tracking?.resendable ?? true
      }
    }
  )

  return message_trackings
}
